import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list (params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { encode: false });
        },
    };

    return axios.get(`${url}/activityGuidances`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function get (id) {
    console.log(id);
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/activityGuidances/${id}?include=activity,guidance,activityShifts,activityTariff,workplace,exceptions`, options)
        .then(response => {
            let activityGuidance = jsona.deserialize(response.data);
            delete activityGuidance.links;
            return activityGuidance;
        });
}

function view (params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { encode: false });
        },
    };

    return axios.get(`${url}/activityGuidances/${params.id}`, options)
        .then(response => {
            let activityGuidance = jsona.deserialize(response.data);
            delete activityGuidance.links;
            return activityGuidance;
        });
}


function show (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/activityGuidances/${id}?include=activity,activityShifts,vessel,workplace,guidance,exceptions`, options)
        .then(response => {
            let activityGuidance = jsona.deserialize(response.data);
            delete activityGuidance.links;
            return activityGuidance;
        });
}

function add (activityGuidance) {
    const payload = jsona.serialize({
        stuff: activityGuidance,
        includeNames: ['activity','activityTariff','activityShifts','workplace','guidance','exceptions']
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/activityGuidances`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function update (activityGuidance) {
    const payload = jsona.serialize({
        stuff: activityGuidance,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };
        // ?include=activity,shift,vessel,workplace,guidance,exceptions
    return axios.patch(`${url}/activityGuidances/${activityGuidance.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function destroy (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(`${url}/activityGuidances/${id}`, options);
}

export default {
    list,
    get,
    view,
    show,
    add,
    update,
    destroy
};

